import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';


@Component({
  selector: 'app-email-not-verified',
  templateUrl: './email-not-verified.component.html',
  styleUrls: ['./email-not-verified.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class EmailNotVerifiedComponent implements OnInit {

  public error$: Observable<any> = this.auth.error$;

  constructor(private auth: AuthService, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.auth.user$.subscribe(user => {
    });
  }
}
